export enum AttachmentTypeCode {
    PCIComplianceDocument = 1
}